import { css } from 'styled-components';
import { breakpoint } from '@zocdoc-frontend-common/styles-grid';
import { FontFamily } from '../constants';

const font = fontFamily => (
    desktopFontSize,
    mobileFontSize,
    letterSpacing,
    lineHeight
) => {
    return css`
        font-family: ${fontFamily};
        line-height: ${lineHeight}px;
        letter-spacing: ${letterSpacing}%;
        font-size: ${mobileFontSize}px;

        ${breakpoint.medium} {
            font-size: ${desktopFontSize}px;
        }
    `;
};

export const sharpSansMedium = font(FontFamily.SharpSansMedium);
export const sharpSansSemibold = font(FontFamily.SharpSansSemibold);
export const sharpSansBold = font(FontFamily.SharpSansBold);
